import { authentication } from "../components/common/authentication";
import {
  getAttachmentsToSync,
  getImagesToSyncCB,
  getSignatureToSyncCB,
} from "../database/helpers/invoice";
import { hasUnsyncedChanges } from "@nozbe/watermelondb/sync";
import {
  getAttachmentsToPaymentSync,
  getImagesToSync,
} from "../database/helpers/payment";
import { getAttachmentsToCashTxnSync } from "../database/helpers/cash_txn";
import { synchronize } from "@nozbe/watermelondb/sync";
import { App_Version, BASE_URL, getBase64FromImageURL } from "../constants";
import { analytics, triggerLogEvent } from "../config/firebase";
import fileDownload from "js-file-download";
import { database } from "../database";
import axios from "axios";
import {
  calculateTotalOutstanding,
  findCustomerByID,
  getAllCustomers,
} from "../database/helpers/customer";
import { getImagesToSyncStock } from "../database/helpers/stock";
import Cookies from "js-cookie";
import { handleApi } from "../apis";
import {
  BUSINESS_REPORT,
  GET_SHARED_ACCOUNTS,
  PAGINATED_SYNC_API_URL,
  POST_SYNC_API_URL,
  POST_UPLOAD_RECEIPT,
  SYNC_API_URL,
} from "../apis/configuration";

const config = {
  timeout: 10000,
};

export const getWalletBalance = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/wallet/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const withdrawWalletV3 = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/withdraw_v3/`;

    axios
      .post(url, params, {
        withCredentials: true,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
          "App-Version": "31.1.8",
          "App-Platform": "android",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendRnpRequest = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/request/invite/`;

    axios
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Token ${Cookies.get("token")}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAuthCookie = (params) => {
  return new Promise((resolve, reject) => {
    const abort = axios.CancelToken.source();
    const id = setTimeout(() => abort.cancel("Timeout"), config.timeout);
    const getCookie = axios.create();

    let url = `${BASE_URL}/udhaar/weblogin/`;

    getCookie
      .post(url, params)
      .then((res) => {
        clearTimeout(id);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const onBoardSignup = (params, BASE_URL) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/accounts/v2/dukaan/create/`;
    let data = {
      username: params.phone_number,
      phone_number: params.phone_number,
      pin: params.pin,
      telco_network: params.telco_network,
      referer: params.referer,
    };

    axios
      .post(url, data)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          resolve(res);
        } else {
          reject("something went wrong");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          reject("User already exist");
        } else {
          reject("something went wrong");
        }
      });
  });
};

export const validateToken = () => {
  let num = localStorage.getItem("phone_number");
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/web/v2/checkauth/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.message === "success" && res.data.phone_number === num) {
          resolve(res);
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
      });

    // axios.get(VALIDATION_TOKEN, {
    //         headers: {
    //             'Authorization': `Token ${token}`,
    //             'Content-Type': 'application/json'
    //         }
    //     }).then(function (response) {
    //         const data = response.data

    //         if (data.message === 'success' && data.phone_number === num) {
    //             resolve();
    //             // getUserFromNumber(num).then(res => {
    //             //     resolve(res);
    //             // })
    //         }
    //         else {
    //             reject("Validation Number error");
    //         }
    //     }).catch(err => {
    //         reject(err)
    //     });
  });
};

export const onBoardManageUser = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/dukaan/create/sendotp/`;

    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendOTP = (params, deviceId) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/web/sendotp/`;

    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json",
          "Web-Token": Cookies.get("deviceId"),
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleCheckKYC = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/accounts/pin/reset/`;

    axios
      .get(url, {
        params,
        headers: {
          "Content-Type": "application/json",
          "Api-Key": process.env.REACT_APP_API_KEY,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const validatePassword = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/webpasswordverify/`;

    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const onBoardCheckUser = (params, BASE_URL) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/accounts/dukaan/check/`;
    axios
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendResetOtp = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/accounts/dukaan/sendpin/`;
    axios
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const resendCode = (params, BASE_URL) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/accounts/dukaan/sendotp/`;
    axios
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const generatePaymentURL = (
  customer_id,
  business_id,
  amount_requested,
) => {
  return new Promise((resolve, reject) => {
    const url = `${BASE_URL}/rnp/send/paymenturl/`;
    const params = {
      customer_id,
      business_id,
      amount_requested,
    };

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postAccountVerification = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/v2/captcha/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleAccountVerification = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/v2/captcha/`;

    axios
      .put(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateWalletBankInfo = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/wallet/`;

    axios
      .put(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateCaptcha = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/captcha/`;

    axios
      .put(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleAsyncWalletDeposit = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/depositweb/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
          "App-Version": "31.1.8",
          "App-Platform": "android",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addPassword = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/webpassword/`;

    axios
      .put(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getWebLock = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/webpassword/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncDepositDetails = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/depositweb/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const depositMoneyIntoOwnWallet = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/merchantdepositmoneyweb/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
          "App-Version": "30.8.7",
          "App-Platform": "android",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const withdrawWallet = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/withdraw_v2/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
          "App-Version": "30.8.7",
          "App-Platform": "android",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response.data);
      });
  });
};

export const getNetworks = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/checkavailablenetworks/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendWalletRecharge = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/sendrechange/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleAsyncWalletRecharge = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/rechargeweb/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
          "App-Version": "31.1.8",
          "App-Platform": "android",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncRechargeDetails = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/rechargeweb/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
          "App-Version": "31.1.8",
          "App-Platform": "android",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handlePostDispute = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/recharge/dispute/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response.data.message);
      });
  });
};

export const getCatalogCategories = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/categories/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCategoryProducts = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/products/${id}/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const searchCategoryProducts = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/catalog/search/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const RETRY_DELAY_MS = 2000;
const MAX_RETRIES = 3;

let syncInProgress = false;
let queuedWaiters = [];

export const Sync = async (number, navigate, fromLogin = false) => {
  if (!number) return;
  if (syncInProgress) {
    return new Promise((resolve, reject) => {
      queuedWaiters.push({ resolve, reject });
    });
  }

  syncInProgress = true;
  try {
  if (navigator.onLine) {
    try {
      await backupImages(navigate);
      await backupAttachments(navigate);
    } catch (err) {
      throw err;
    }

    let time = fromLogin ? null : await localStorage.getItem(number);
    let customersToUpdate;
    let capturedTimestamp = null;

    try {
      await synchronize({
        database,
        pullChanges: async ({ lastPulledAt, schemaVersion, migration }) => {
          lastPulledAt = time ? Number(time) : null;

          let syncStatus = await hasUnsyncedChanges({ database });
          let response,
            totalPages = 1,
            page = 1;

          if (lastPulledAt == null) {
            let dukaan_sync_timestamp = null;

            do {
              let pageSuccess = false;
              let retries = 0;

              while (!pageSuccess && retries < MAX_RETRIES) {
                try {
                  let resp = await handleApi(
                    PAGINATED_SYNC_API_URL,
                    {
                      hasUnsyncedChanges: syncStatus,
                      dukaan_sync_timestamp,
                      lastPulledAt,
                      page,
                    },
                    null,
                    navigate,
                    {
                      "Web-Token": `${Cookies.get("deviceId")}`,
                    },
                  );

                  const { changes, pages } = resp;

                  if (page == 1) response = { ...resp };
                  else {
                    Object.keys(changes).forEach((key) => {
                      if (key == "user") return;

                      response.changes[key].updated = [
                        ...(response.changes[key].updated || []),
                        ...(changes[key].updated || []),
                      ];
                      response.changes[key].created = [
                        ...(response.changes[key].created || []),
                        ...(changes[key].created || []),
                      ];
                      response.changes[key].deleted = [
                        ...(response.changes[key].deleted || []),
                        ...(changes[key].deleted || []),
                      ];
                    });
                  }

                  if (page == 1)
                    dukaan_sync_timestamp = resp.dukaan_sync_timestamp;

                  pageSuccess = true;
                  totalPages = pages;
                  page += 1;
                } catch (err) {
                  retries++;
                  console.error(
                    `ERROR: API request failed on page ${page}, retrying... (${retries}/${MAX_RETRIES})`,
                  );

                  if (retries < MAX_RETRIES) {
                    await delay(RETRY_DELAY_MS);
                  } else {
                    throw err;
                  }
                }
              }
            } while (totalPages >= page);
          } else {
            response = await handleApi(
              SYNC_API_URL,
              {
                hasUnsyncedChanges: syncStatus,
                schemaVersion,
                lastPulledAt,
                migration,
              },
              null,
              navigate,
              {
                "Web-Token": `${Cookies.get("deviceId")}`,
              },
            );
          }

          const {
            is_marketplace_seller,
            sync_timestamp,
            web_version,
            is_pin_set,
            changes,
          } = response || {};

          if (is_pin_set !== undefined && !is_pin_set) {
            const OTPresponse = await sendOTP({
              version: "multi-business",
              onboarding_type: "login",
              phone_number: number,
            });

            if (navigate) {
              navigate("/CompleteOnboarding", {
                state: {
                  isCompleteOnboarding: true,
                  sendOTPResponse: OTPresponse.data,
                },
              });
            }
          }

          // if (web_version && web_version !== App_Version) {
          //   document.getElementById("myModal").style.display = "flex";
          // }

          if (is_marketplace_seller) {
            localStorage.setItem("is_marketplace_seller", "true");
          } else localStorage.removeItem("is_marketplace_seller");

          if (sync_timestamp) {
            capturedTimestamp = sync_timestamp;
          }

          if (changes?.customer?.updated?.length) {
            customersToUpdate = changes.customer.updated;
          }

          let timestamp = sync_timestamp;

          return { changes, timestamp };
        },
        pushChanges: async ({ changes, lastPulledAt }) => {
          lastPulledAt = time ? Number(time) : null;

          let params = {
            params: {
              changes,
            },
          };

          const response = await handleApi(
            POST_SYNC_API_URL,
            params,
            null,
            navigate,
            {
              "Web-Token": `${Cookies.get("deviceId")}`,
            },
          );

          const { is_pin_set } = response || {};

          if (!is_pin_set) {
            const OTPresponse = await sendOTP({
              version: "multi-business",
              onboarding_type: "login",
              phone_number: number,
            });

            if (navigate) {
              navigate("/CompleteOnboarding", {
                state: {
                  isCompleteOnboarding: true,
                  sendOTPResponse: OTPresponse.data,
                },
              });
            }
          }
        },
      });

      if (capturedTimestamp) {
        localStorage.setItem(number, capturedTimestamp.toString());
      } else {
        console.warn("[SYNC] Sync complete but no timestamp received from server");
      }
    } catch (err) {
      console.error("[SYNC] Sync failed:", err?.response?.status, err?.response?.data?.detail || err?.message);
      if (err.response?.status === 401 || err.response?.status === 403) {
        authentication(false, navigate, true);
      }

      throw err;
    }

    if (customersToUpdate) {
      try {
        await manageCustomersOutstanding(customersToUpdate);
      } catch (err) {
        console.error("[SYNC] manageCustomersOutstanding failed:", err?.message || err);
      }
    }
  }
  } finally {
    syncInProgress = false;
    if (queuedWaiters.length) {
      const waiters = queuedWaiters;
      queuedWaiters = [];
      Sync(number, navigate, fromLogin)
        .then((result) => waiters.forEach((waiter) => waiter.resolve(result)))
        .catch((err) => waiters.forEach((waiter) => waiter.reject(err)));
    }
  }
};

const backupAttachments = async (navigate) => {
  try {
    const invoiceAttachments = (await getAttachmentsToSync()) || [];
    const paymentAttachments = (await getAttachmentsToPaymentSync()) || [];
    const cashTxnAttachments = (await getAttachmentsToCashTxnSync()) || [];
    const contactAttachments = [
      ...invoiceAttachments,
      ...paymentAttachments,
      ...cashTxnAttachments,
    ];
    if (!contactAttachments?.length) {
      return;
    }

    for (const txns of contactAttachments) {
      const updatedArr = [];

      const uploadPromises = (txns?.attachment || []).map(async (val) => {
        const valStr = String(val?.file || "");

        if (!valStr.includes("data")) {
          updatedArr.push({ file: valStr, name: val?.name, type: val?.type });
          return;
        }

        try {
          const base64 = valStr.split(",");
          if (!base64[1]) {
            console.error("Removing invalid/empty base64 attachment from record");
            return;
          }
          const formData = new FormData();
          const isImage =
            val.type !== "application/pdf" &&
            val.type !== "application/vnd.ms-excel" &&
            val.type !== "text/plain" &&
            val.type !== "application/msword";

          formData.append("transaction_id", txns.id);
          formData.append(
            isImage ? "image_type" : "type",
            isImage ? "jpeg" : val.name?.split?.(".")[1] || "pdf",
          );
          formData.append(isImage ? "receipt" : "doc", base64[1]);
          formData.append("content_type", val.type);

          const upload = await handleApi(
            POST_UPLOAD_RECEIPT,
            formData,
            null,
            navigate,
            {
              "Content-Type": "multipart/form-data",
            },
          );

          if (upload?.url) {
            updatedArr.push({ file: upload.url, name: val.name, type: val.type });
          }
        } catch (err) {
          const isInvalid =
            err?.response?.data?.error_code === "invalid_file" ||
            err?.response?.data?.error === "invalid_file" ||
            err?.response?.data?.message?.toLowerCase?.()?.includes("invalid") ||
            err?.response?.status === 400 ||
            err?.response?.status === 422;

          if (isInvalid) {
            console.error(
              "Removing corrupt/invalid attachment from record:",
              err?.response?.data?.message || err.message,
            );
            return;
          }
          console.error("Failed to upload attachment:", err.message);
          throw err;
        }
      });

      const results = await Promise.allSettled(uploadPromises);
      const failed = results.filter((r) => r.status === "rejected");

      if (failed.length > 0) {
        throw new Error(`Failed to upload ${failed.length} attachment(s)`);
      }

      if (txns.table === "payment" || (txns.updatePaymentAttachments && !txns.updateInvoiceAttachments)) {
        await txns.updatePaymentAttachments(updatedArr);
      } else if (txns.table === "cash_txn" || txns.updateCashTxnAttachments) {
        await txns.updateCashTxnAttachments(updatedArr);
      } else if (txns.table === "invoice" || txns.updateInvoiceAttachments) {
        await txns.updateInvoiceAttachments(updatedArr);
      }
    }
  } catch (err) {
    console.error("ERROR: BACK-UP ATTACHMENTS FAILED", err.message || err);
    throw err;
  }
};

const backupSingleImage = async (payment, navigate) => {
  if (payment.image_url) {
    const base64 = payment.image_url.split(",");
    let formData = new FormData();

    formData.append("transaction_id", payment.id);
    formData.append("image_type", "jpeg");
    formData.append("receipt", base64[1]);

    const data = await handleApi(POST_UPLOAD_RECEIPT, formData, null, navigate);
    const imageURL = data.url;
    if (payment.payment_mode) {
      await payment.updatePaymentImage(imageURL);
    } else if (payment.inclusive) {
      await payment.updateStockImage(imageURL);
    } else {
      await payment.updateInvoiceImage(imageURL);
    }
  } else if (payment?.signature && payment?.signature.includes("data:image")) {
    let val = {
      type: "signature",
      value: getBase64FromImageURL(payment.signature),
    };

    let SignFormData = new FormData();
    SignFormData.append("transaction_id", payment.id);
    SignFormData.append("image_type", "jpeg");
    SignFormData.append("receipt", val?.value);
    const imageUri = await handleApi(POST_UPLOAD_RECEIPT, SignFormData, null, navigate);
    if (val?.type == "signature") {
      await payment.updateInvoiceSignature(imageUri?.url);
    }
  } else {
    if (payment.payment_mode) {
      await payment.updatePaymentImage("");
    } else if (payment.inclusive) {
      await payment.updateStockImage("");
    } else {
      await payment.updateInvoiceImage("");
    }
  }
};

const backupImages = async (navigate) => {
  let imagesForSync = await getImagesToSync();
  let imagesForSyncCB = await getImagesToSyncCB();
  let signatureToSyncCB = await getSignatureToSyncCB();
  let imagesForStock = await getImagesToSyncStock();
  imagesForSync = imagesForSync
    .concat(imagesForSyncCB)
    .concat(signatureToSyncCB)
    .concat(imagesForStock);

  if (!imagesForSync.length) return;

  const results = await Promise.allSettled(
    imagesForSync.map((payment) => backupSingleImage(payment, navigate)),
  );

  const failed = results.filter((r) => r.status === "rejected");
  if (failed.length > 0) {
    throw new Error(`Failed to upload ${failed.length} image(s)/signature(s)`);
  }
};

// const fetchDataForSync = () => {
//     return new Promise(async (resolve, reject) => {
//         try {
//             let user_id = await localStorage.getItem('session_id')

//             let customers_data = [];
//             let payments_data = [];
//             let recordsForDeletion = [];
//             let business_data = [];
//             let invoice_data = [];
//             let items_data = [];

//             let realm = await OpenDB.openRealmDb()

//             customers_data = await CustomerDB.getCustomersForSynching(realm, user_id)
//             payments_data = await PaymentDB.getPaymentsForSynching(realm, user_id)
//             business_data = await BusinessDB.getBusinessForSyncing(realm, user_id)
//             invoice_data = await InvoiceDB.getInvoicesForSynching(realm, user_id)
//             items_data = await ItemDB.getItemsForSynching(realm, user_id)
//             recordsForDeletion = await DeleteRecordDB.getRecordsForDeletion(realm)

//             resolve({
//                 customers_data,
//                 payments_data,
//                 business_data,
//                 invoice_data,
//                 items_data,
//                 recordsForDeletion
//             })
//         } catch (err) {
//             reject(err)
//         }
//     })
// }

export const DataRestoreProcess = (user, navigate) => {
  return new Promise((resolve, reject) => {
    Sync(user.phone_number, navigate, true)
      .then(async () => {
        manageCustomersOutstanding()
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.error("[DataRestoreProcess] manageCustomersOutstanding failed:", err?.message || err);
            resolve();
          });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const manageCustomersOutstanding = (updatedCustomers = false) => {
  return new Promise(async (resolve, reject) => {
    try {
      let customers = updatedCustomers
        ? updatedCustomers
        : await getAllCustomers();

      Promise.all(
        customers.map(async (customer) => {
          customer = updatedCustomers
            ? await findCustomerByID(customer.id)
            : customer;
          let total = await calculateTotalOutstanding(customer);

          if (total !== customer.total_outstanding_payment) {
            await customer.updateTotalOutstanding(total).then(() => {
              triggerLogEvent(analytics, "balance_issue_detected", {});
            });
          }
        }),
      )
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const payOnlineSalary = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/salary/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCustomerDetails = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billingcustomers/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBillingCategories = () => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billingoptions/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postAsyncBillingInquiry = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billinginquire/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncBillingInquiry = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billinginquire/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postAsyncBillingPayment = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billpay/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncBillingPayment = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billpay/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCustomerBillingHistory = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/billingconsumers/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postAsyncRetailerDeposit = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/easypaisa/retailerdeposit/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncRetailerDeposit = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/easypaisa/retailerdeposit/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postAsyncCreateAccount = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/easypaisa/createaccount/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncCreateAccount = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/easypaisa/createaccount/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postAsyncRetailerWithdraw = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/easypaisa/retailerwithdraw/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAsyncAsyncRetailerWithdraw = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/rnp/easypaisa/retailerwithdraw/`;

    axios
      .get(url, {
        params,
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postDownloadPDF = (params) => {
  return new Promise((resolve, reject) => {
    const url = `${BASE_URL}/udhaar/web/pdf/v2/`;

    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
        withCredentials: true,
      })
      .then((res) => {
        fileDownload(res.data, params.name);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postDownloadSupplierInvoice = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/udhaar/pdf/`;
    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, "Supplier invoice");
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postUploadStockFile = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/seller/bulkupload/`;

    axios
      .post(url, params, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        // responseType: "blob",
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getStockFileTemplate = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/seller/bulkupload/`;

    axios
      .get(url, {
        headers: {
          Authorization: `Token ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInsurance = (params) => {
  return new Promise((resolve, reject) => {
    let url = `https://udhaar-api-stage.oscar.pk/services/insurance/`;

    axios
      .get(url, { params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const PostInsuranceParams = (params) => {
  return new Promise((resolve, reject) => {
    let url = `https://udhaar-api-stage.oscar.pk/services/insurance/confirm/`;

    axios
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleBusinessReportUrl = async (business, navigate) => {
  let params = { business_id: business.id };
  try {
    const resp = await getBusinessReportUrl(params, navigate);
    return resp?.report_url;
  } catch (error) {
  }
};

export const getBusinessReportUrl = (params, navigate) => {
  return new Promise((resolve, reject) => {
    handleApi(BUSINESS_REPORT, params, null, navigate)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSharedAccount = (params, navigate) => {
  return new Promise((resolve, reject) => {
    handleApi(GET_SHARED_ACCOUNTS, params, null, navigate)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
